var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["product-card", { "single-image": _vm.images.length === 1 }] },
    [
      _vm.LOADING ? _c("ui-loader", { attrs: { size: "60" } }) : _vm._e(),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "div",
            { staticClass: "info-header" },
            [
              _c("product-markers", {
                attrs: {
                  markers: _vm.PRODUCT.markers,
                  plates: _vm.PRODUCT.plates
                }
              }),
              _c("h1", { staticClass: "title" }, [
                _c("span", [_vm._v(_vm._s(_vm.PRODUCT.name))]),
                _vm._v("\n        " + _vm._s(_vm.PRODUCT.code) + "\n      ")
              ]),
              _c("favorite-button", {
                attrs: {
                  "product-id": _vm.PRODUCT.id,
                  "product-code": _vm.PRODUCT.code,
                  "product-price": _vm.currentPrice,
                  "sku-id": _vm.ACTIVE_SKU.id
                },
                on: { change: _vm.onChangeFavorite }
              })
            ],
            1
          ),
          _c("vue-client-only", [
            _c(
              "div",
              { staticClass: "gallery" },
              [
                _vm.adaptive.isMobile
                  ? _c("swiper", {
                      attrs: {
                        items: _vm.images,
                        "slides-to-show": 1,
                        dots: ""
                      },
                      on: { change: _vm.onChangeImageSlide },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(ref) {
                              var item = ref.item
                              return [
                                _c("media", {
                                  attrs: {
                                    media: item,
                                    width: "400",
                                    alt: _vm.PRODUCT.name
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        1112071276
                      )
                    })
                  : _vm._l(_vm.images, function(image) {
                      return _c(
                        "div",
                        { key: image.id, staticClass: "image-container" },
                        [
                          _c("media", {
                            attrs: {
                              media: image,
                              width: _vm.images.length > 1 ? 400 : 800,
                              alt: _vm.PRODUCT.name
                            }
                          })
                        ],
                        1
                      )
                    })
              ],
              2
            )
          ]),
          _c(
            "div",
            { staticClass: "info-content" },
            [
              _c("div", { staticClass: "prices" }, [
                _c(
                  "div",
                  { class: ["price price-rub", { discount: _vm.isDiscount }] },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm._f("price")(_vm.currentPrice)) +
                        "\n        "
                    )
                  ]
                ),
                _vm.isDiscount
                  ? _c("div", { staticClass: "old-price" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm._f("price")(_vm.PRODUCT.price.basePrice)) +
                          "\n        "
                      )
                    ])
                  : _vm._e()
              ]),
              _c("select-color", {
                attrs: {
                  "show-color-name": "",
                  label: "Цвета",
                  colors: _vm.COLORS,
                  "active-color": _vm.ACTIVE_COLOR
                },
                on: { change: _vm.onChangeColor }
              }),
              _c(
                "select-size",
                {
                  attrs: {
                    "visible-hint": "",
                    label: "Размеры",
                    sizes: _vm.SIZES,
                    "active-sku": _vm.ACTIVE_SKU
                  },
                  on: { change: _vm.chooseSize }
                },
                [
                  _vm.PRODUCT.sizeTable
                    ? _c("size-table", {
                        attrs: { "product-id": _vm.PRODUCT.id },
                        on: { open: _vm.onOpenSizeTable }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c("to-cart", {
                staticClass: "product-card__to-cart",
                attrs: {
                  product: _vm.PRODUCT,
                  "sku-id": _vm.ACTIVE_SKU.id,
                  price: _vm.PRODUCT.price.basePrice,
                  "discount-price": _vm.PRODUCT.price.discountPrice,
                  "text-add": _vm.csmToken && "Добавить в заказ в CSM"
                },
                on: {
                  add: _vm.onAddProductToCart,
                  "to-cart": _vm.onRedirectToCart
                }
              }),
              !_vm.PRODUCT.available
                ? _c("ui-notification", {
                    staticClass: "sold-out",
                    attrs: { title: "Товар распродан" }
                  })
                : _vm._e(),
              _c("product-delivery", {
                staticClass: "product-card__product-delivery",
                attrs: {
                  "active-sku": _vm.ACTIVE_SKU,
                  "availability-stores": _vm.AVAILABILITY_LIST
                },
                on: { click: _vm.onClickProductDelivery }
              }),
              _c("product-bonus", { attrs: { bonus: _vm.PRODUCT.bonus } }),
              _c("info-menu", {
                staticClass: "product-card__info",
                attrs: {
                  "product-code": _vm.PRODUCT.code,
                  "city-name": _vm.CITY.name,
                  "active-sku": _vm.ACTIVE_SKU
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }